export const GET_CUSTOM_ATTRIBUTES_FAILED = 'Failed to obtain Custom Attributes';
export const ADD_CUSTOM_ATTRIBUTES_FAILED = 'Failed to add Custom Attributes';
export const EDIT_CUSTOM_ATTRIBUTES_FAILED = 'Failed to edit Custom Attributes';
export const REMOVE_CUSTOM_ATTRIBUTE_FAILED = 'Failed to remove Custom Attributes';
export const APPLY_CHANGES_FAILED = 'Failed to save changes';
